const index = () => import('./index');
const productCenterIndex = () => import('./productCenter/index');
const smartChatIndex = () => import('./smartChat/index');
const smartChatSetting = () => import('./smartChat/setting');

const toolboxRouter = [
  {
    path: '/toolbox/index', name: 'toolboxIndex', component: index, meta: { c: 'toolbox', a: 'index' }
  },
  {
    path: '/productCenter/index', name: 'productCenterIndex', component: productCenterIndex, meta: { c: 'productCenter', a: 'index' }
  },
  {
    path: '/smartChat/index', name: 'smartChatIndex', component: smartChatIndex, meta: { c: 'smartChat', a: 'index' }
  },
  {
    path: '/smartChat/setting', name: 'smartChatSetting', component: smartChatSetting, meta: { c: 'smartChat', a: 'setting' }
  },
];

export default toolboxRouter;
